<form>
  <section class="mt-5">
    <!-- <h4 class="text-h4 font-bold">{{ 'site_setup_contract_provide_details' | translate }}</h4> -->
    <div class="rounded-3xl bg-background-light-grey py-5">
      <cdk-accordion [multi]="true">
        @if (!showSignerEmail) {
          <lib-license-agreement-practice-form></lib-license-agreement-practice-form>
          <hr class="mx-5 my-4 border-background-disabled" />
        }
        <lib-license-agreement-signer-form
          [showSignerEmail]="showSignerEmail"
          [showAuthorizedCheckbox]="showAuthorizedCheckbox"
        ></lib-license-agreement-signer-form>
        @if (showSignerEmail) {
          <hr class="mx-5 my-4 border-background-disabled" />
          <lib-license-agreement-practice-form></lib-license-agreement-practice-form>
        }
      </cdk-accordion>
    </div>
  </section>

  @if (!showSignerEmail) {
    <section class="mt-10">
      <!-- <h4 class="text-h4 font-bold">{{ 'site_setup_contract_sign_contract' | translate }}</h4> -->

      <!-- <p class="mt-4 text-h4 font-light">{{ today }}</p> -->
      <lib-license-agreement-sign-box></lib-license-agreement-sign-box>
    </section>
  }
</form>
